import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import $ from 'jquery';
import { levelAtConstant } from '@bingads-webui-campaign/scope-constants';
import {
  RECOMMENDATIOIN_SUMMARY_APPLY_FAILED_RESULTS,
  ADINSIGHT_LOG_API_NAME,
  CHANNEL_TYPES,
  RECOMMENDATION_IDS,
  ADINSIGHT_LOG_ACTION_TYPE,
  CONTEXTUAL_ENTITY_TYPE,
  DOWNLOAD_SCOPE,
  RECOMMENDATION_TYPES,
} from '@bingads-webui-campaign/recommendation-core';
import { formatNotificationLocalizedKey } from '@bingads-webui-campaign/recommendation-notification';
import { RecommendationStatusLightbox } from '@bingads-webui-campaign/recommendation-status-lightbox';
import { getSessionStorage } from '@bingads-webui/storage';

import {
  NewRecommendationsGrid,
  getConfig,
  isPopupEditorEnabledRecommendationType,
  filterByOpportunityId,
  removeFilter,
} from '@bingads-webui-campaign/recommendation-grid';

import { getToolbarConfig } from './toolbar-config';

export class RecommendationsGridContainer extends React.Component {
  static propTypes = {
    recommendationService: PropTypes.shape({
      getSummary: PropTypes.func.isRequired,
      getCount: PropTypes.func.isRequired,
      track: PropTypes.func.isRequired,
    }).isRequired,
    downloadService: PropTypes.objectOf(PropTypes.any),
    scope: PropTypes.shape({
      customerId: PropTypes.number.isRequired,
      accountId: PropTypes.number.isRequired,
      levelAt: PropTypes.string.isRequired,
      campaignId: PropTypes.number,
    }).isRequired,
    vnextDeps: PropTypes.shape({
      newI18n: PropTypes.PropTypes.shape({
        getString: PropTypes.func.isRequired,
      }).isRequired,
      getCrossPageSelectPlugin: PropTypes.func.isRequired,
      getToolbarPlugin: PropTypes.func.isRequired,
      StyledGridViewWrapper: PropTypes.objectOf(PropTypes.any),
      StyledTablePageContainer: PropTypes.objectOf(PropTypes.any),
      ToolbarContainer: PropTypes.objectOf(PropTypes.any),
      GoalCreationRecommendationWizard: PropTypes.objectOf(PropTypes.any),
    }).isRequired,
    deps: PropTypes.objectOf(PropTypes.any),
    recommendationType: PropTypes.string,
    campaignType: PropTypes.number,
    onEvent: PropTypes.func.isRequired,
    context: PropTypes.shape({
      Level: PropTypes.string.isRequired,
    }).isRequired,
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    guid: PropTypes.string, // for adinsight view event log in aria
    version: PropTypes.number.isRequired,
    primaryEstimate: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
    perfMarker: PropTypes.object,
    isMCC: PropTypes.bool,
    topOfGridContent: PropTypes.node,
    readOnly: PropTypes.bool,
    channel: PropTypes.string,
    compact: PropTypes.bool,
    overallOptimizationScoreBar: PropTypes.shape({
      Gained: PropTypes.number,
      Dismissed: PropTypes.number,
      Available: PropTypes.number,
    }),
    viewDetails: PropTypes.func,
    recommendationTypesAvailable: PropTypes.arrayOf(PropTypes.string),
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }),
    s$i18n: PropTypes.PropTypes.shape({
      value: PropTypes.func,
    }),
    data: PropTypes.objectOf(PropTypes.any),
    isOptimizationScoreOn: PropTypes.bool,
    serverContext: PropTypes.shape({}),
    setData: PropTypes.func.isRequired,
    setDataFromDetails: PropTypes.func.isRequired,
    viewUET: PropTypes.func,
  };

  static defaultProps = {
    deps: {},
    downloadService: null,
    recommendationType: null,
    campaignType: null,
    isMCC: false,
    guid: null,
    primaryEstimate: '',
    topOfGridContent: null,
    readOnly: false,
    channel: undefined,
    compact: false,
    overallOptimizationScoreBar: false,
    viewDetails: _.noop,
    recommendationTypesAvailable: [],
    newI18n: {
      getString: _.noop,
    },
    s$i18n: {
      value: _.noop,
    },
    data: {},
    isOptimizationScoreOn: false,
    serverContext: {},
    viewUET: _.noop,
  };

  constructor(props) {
    super(props);
    const {
      deps,
      i18n,
      recommendationType,
      recommendationService,
      downloadService,
      onEvent,
      context,
      guid,
      version,
      perfMarker,
      primaryEstimate,
      isMCC,
      vnextDeps,
      readOnly,
      channel,
      compact,
    } = props;

    if (perfMarker) {
      this.perfMarker = perfMarker.createChild('RecommendationDetailsGrid', { autoEnd: true });
      this.perfMarker.willInit();
    }

    this.crossPageSelectPlugin = vnextDeps.getCrossPageSelectPlugin({
      updateGridSelectionState: this.updateGridSelectionState,
    });
    this.onSelectCrossPage = this.crossPageSelectPlugin.onSelectCrossPage;

    // toolbar settings begin
    this.toolbarConfig = this.getNewToolbarConfig();

    this.state = {
      showToolbarUnselected: true,
      showToolbarSelected: false,
      toolbarSelectedConfig: this.toolbarConfig.toolbarSelectedConfig,
      toolbarUnselectedConfig: this.toolbarConfig.toolbarUnselectedConfig,
      forceHideToolbar: false,
      backboneGridView: null,
      recommendationsGrid: null,
    };

    this.filterState = {};

    this.newToolBarPlugin = vnextDeps.getToolbarPlugin({
      resetVisibility: ({ forceHideToolbar }) => {
        this.setState({
          forceHideToolbar,
          toolbarSelectedConfig: this.toolbarConfig.toolbarSelectedConfig,
          toolbarUnselectedConfig: this.toolbarConfig.toolbarUnselectedConfig,
        });
      },
      resetToolbarMode: ({ showToolbarSelected, showToolbarUnselected }) => {
        this.updateToolbarConfig({ showToolbarSelected, showToolbarUnselected });
      },
      toolbarConfig: {
        toolbarSelectedConfig: this.state.toolbarSelectedConfig,
        toolbarUnselectedConfig: this.state.toolbarUnselectedConfig,
      },
      updateToolbar: () => {
        this.updateToolbarConfig();
      },
    }).plugin;
    // toolbar settings end

    this.deps = deps;
    this.i18n = i18n;
    this.recommendationType = recommendationType;
    this.recommendationService = recommendationService;
    this.downloadService = downloadService;
    this.onEvent = onEvent;
    this.isMCC = isMCC;
    this.context = context;
    this.guid = guid;
    this.version = version;
    this.primaryEstimate = primaryEstimate || '';
    this.readOnly = readOnly;
    this.channel = channel;
    this.compact = compact;
  }

  componentDidMount() {
    const { StyledGridViewWrapper, GoalCreationRecommendationWizard } = this.props.vnextDeps;

    const config = getConfig({
      deps: this.deps,
      i18n: this.i18n,
      newI18n: this.props.newI18n,
      s$i18n: this.props.s$i18n,
      recommendationType: this.recommendationType,
      recommendationService: this.recommendationService,
      campaignType: this.props.campaignType,
      el: $('.grid-and-disclaim-container'),
      downloadService: this.downloadService,
      onEvent: this.onEvent,
      view: this,
      logOpportunityEvent: this.logOpportunityEvent,
      perfMarker: this.perfMarker,
      context: this.props.context,
      guid: this.guid,
      primaryEstimate: this.primaryEstimate,
      isMCC: this.isMCC,
      router: this.router.bind(this),
      readOnly: this.readOnly,
      channel: this.channel,
      compact: this.compact,
      isOptimizationScoreOn: this.props.isOptimizationScoreOn,
      viewDetails: this.props.viewDetails,
      recommendationTypesAvailable: this.props.recommendationTypesAvailable,
      scope: this.props.scope,
      filterState: this.filterState,
      data: this.props.data && this.props.data[this.recommendationType],
      serverContext: this.props.serverContext,
      setData: this.props.setData,
      setDataFromDetails: this.props.setDataFromDetails,
      getGoalCreationRecommendationWizard: GoalCreationRecommendationWizard,
      viewUET: this.props.viewUET,
    });

    const backboneGridView = new NewRecommendationsGrid({
      i18n: this.i18n,
      deps: this.deps,
      config,
      logOpportunityEvent: this.logOpportunityEvent,
      recommendationType: this.recommendationType,
      recommendationService: this.recommendationService,
      downloadService: this.downloadService,
      crossPageSelectPlugin: this.crossPageSelectPlugin,
      newToolBarPlugin: this.newToolBarPlugin,
      onEvent: this.onEvent,
      readOnly: this.readOnly,
      isMCC: this.isMCC,
      compact: this.compact,
      s$i18n: this.props.s$i18n,
      newI18n: this.props.newI18n,
    });

    this.grid = backboneGridView.grid;

    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      recommendationsGrid: (<StyledGridViewWrapper gridView={backboneGridView} />),
      backboneGridView,
    });


    // notification lightbox
    const applyFailedResults = getSessionStorage().get(RECOMMENDATIOIN_SUMMARY_APPLY_FAILED_RESULTS); // eslint-disable-line
    const applyFailed = applyFailedResults !== null && applyFailedResults.recommendationType === this.recommendationType; // eslint-disable-line

    this.statusLightBox = new RecommendationStatusLightbox({
      results: applyFailed ? applyFailedResults.results : null,
      i18n: this.i18n,
      newI18n: this.props.newI18n,
      view: backboneGridView,
      filterByOpportunityId,
      removeFilter,
      recommendationType: this.recommendationType,
      formatNotificationLocalizedKey,
      currentActivity: this.recommendationService.currentActivity,
    });
    this.statusLightBox.render();

    if (applyFailed) {
      this.statusLightBox.trigger('show');
    } else {
      getSessionStorage().clear();
    }

    $('.notification-container').append(this.statusLightBox.$el);
  }

  getNewToolbarConfig = () => {
    const {
      deps,
      i18n,
      newI18n,
      recommendationType,
      onEvent,
      readOnly,
      compact,
      context,
    } = this.props;

    const newToolbarConfig = getToolbarConfig({
      recommendationType,
      gridView: this.grid && this.grid.gridView,
      i18n,
      newI18n,
      onSelectCrossPage: this.onSelectCrossPage,
      onEvent,
      readOnly,
      compact,
      permissions: deps.permissions,
      context,
    });

    if (_.isUndefined(this.toolbarConfig)) {
      return newToolbarConfig;
    }

    // Save original dropdown date filter button text in dropdownDateFilterButtonText
    const dropdownDateFilter =
      this.toolbarConfig.toolbarUnselectedConfig.get('dropdown-date-filter');
    let dropdownDateFilterButtonText;
    if (!_.isUndefined(dropdownDateFilter)) {
      dropdownDateFilterButtonText = dropdownDateFilter.button.text;
    }

    // Merge new toolbar config into the current one
    this.toolbarConfig.toolbarSelectedConfig.forEach((component, key) =>
      _.merge(component, newToolbarConfig.toolbarSelectedConfig.get(key)));
    this.toolbarConfig.toolbarUnselectedConfig.forEach((component, key) =>
      _.merge(component, newToolbarConfig.toolbarUnselectedConfig.get(key)));

    // Restore the original dropdowm date filter button text
    if (!_.isUndefined(dropdownDateFilterButtonText)) {
      this.toolbarConfig.toolbarUnselectedConfig.get('dropdown-date-filter').button.text =
        dropdownDateFilterButtonText;
    }

    return this.toolbarConfig;
  }

  updateToolbarConfig = (state) => {
    const {
      toolbarSelectedConfig,
      toolbarUnselectedConfig,
    } = this.getNewToolbarConfig();
    this.setState({
      toolbarSelectedConfig,
      toolbarUnselectedConfig,
      ...state,
    });
  }

  updateGridSelectionState = ({
    selectionCount,
    totalCount,
    isMultiPage,
    isSinglePageAllSelected,
    isCrossPageAllSelected,
  }) => {
    this.setState({
      selectionCount,
      totalCount,
      isMultiPage,
      isSinglePageAllSelected,
      isCrossPageAllSelected,
    });
  }

  router(e, data = null) { // data for panelEdit
    const target = $(e.target);
    // only account or campaign or adgroup contextual attribute can be clicked to redirect
    if (!_.contains([
      CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
      CONTEXTUAL_ENTITY_TYPE.ADGROUP,
      CONTEXTUAL_ENTITY_TYPE.ACCOUNT,
    ], target.data('type'))) { // eslint-disable-line
      return;
    }
    const levelAt = target.data('type');
    const entityid = target.data('entityid');
    const campaignId = target.data('entitycampaignid');
    const { scope } = this.recommendationService;
    const key = $(e.target).parents('tr[data-key]').data('key') || $(e.target).parents('tr[key]').attr('key');
    const recommendation = this.grid.gridView.itemWithKey(key) || data; // data for panelEdit
    const accountId = recommendation.Target.AccountId;

    if (isPopupEditorEnabledRecommendationType(this.recommendationType)
      && levelAt === levelAtConstant.ADGROUP) {
      return;
    }
    if (levelAt !== scope.levelAt) {
      const scopedata = {
        ...scope,
        levelAt,
        adGroupId: entityid,
        campaignId: campaignId || entityid,
        accountId,
      };
      this.onEvent('updateScope', scopedata);
    }
  }

  logOpportunityEvent = ({
    opportunityId = null,
    campaignId = null,
    input = null,
    type,
    action,
    accountId,
    context = {},
  }) => {
    this.recommendationService.currentActivity.trace({
      id: opportunityId,
      type,
      typeId: RECOMMENDATION_IDS[type],
      action,
      campaignId,
      channel: this.props.isMCC ? CHANNEL_TYPES.MCCRECOMMENDATION : CHANNEL_TYPES.RECOMMENDATION,
      context: action === ADINSIGHT_LOG_ACTION_TYPE.DOWNLOAD ?
        JSON.stringify(_.extend({
          Version: this.version,
          DownloadScope: DOWNLOAD_SCOPE.INDIVIDUAL,
        }, this.props.context)) :
        JSON.stringify(_.extend({}, this.props.context, context)),
      guid: this.guid,
      input,
      accountId,
    }, ADINSIGHT_LOG_API_NAME.RECOMMENDATION);
  }

  render() {
    const {
      forceHideToolbar,
      isCrossPageAllSelected,
      isMultiPage,
      isSinglePageAllSelected,
      selectionCount,
      showToolbarSelected,
      showToolbarUnselected,
      toolbarSelectedConfig,
      toolbarUnselectedConfig,
      totalCount,
    } = this.state;

    const {
      StyledTablePageContainer,
      ToolbarContainer,
    } = this.props.vnextDeps;

    const stickyTopOfGridContent = (
      <Fragment>
        <div className="notification-container" />
        <ToolbarContainer
          forceHideToolbar={forceHideToolbar}
          i18n={this.props.vnextDeps.newI18n}
          isCrossPageAllSelected={isCrossPageAllSelected}
          isMultiPage={this.recommendationType === RECOMMENDATION_TYPES.IMAGE_EXTENSION ?
            false : isMultiPage}
          isSinglePageAllSelected={isSinglePageAllSelected}
          selectionCount={selectionCount}
          showToolbarSelected={showToolbarSelected}
          showToolbarUnselected={showToolbarUnselected}
          toolbarSelectedConfig={toolbarSelectedConfig}
          toolbarUnselectedConfig={toolbarUnselectedConfig}
          totalCount={totalCount}
          onClear={() => {
            this.setState({
              showToolbarSelected: false,
              showToolbarUnselected: true,
            });
            this.state.backboneGridView.grid.gridView.deselectAll();
          }}
        />
        <div className="filterBanner-container" />
      </Fragment>
    );

    return (
      <div className="recommendation-grid">
        <StyledTablePageContainer
          topOfGridContent={this.props.topOfGridContent}
          stickyTopOfGridContent={stickyTopOfGridContent}
          gridView={this.state.recommendationsGrid}
          backboneGridView={this.state.backboneGridView}
          customClasses={{
            tablePageContainer: 'recommendation-grid-page',
          }}
        />
      </div>
    );
  }
}
